document.addEventListener('DOMContentLoaded', () => {
  function  rwGetCookie (name) {
    var match = document.cookie.match(new RegExp('(^|;\\s*)' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[2]) : null;
  };            

  function extractVideoInfo(playerElement, index) {
    const iframe = playerElement.querySelector('iframe[src*="youtube.com/embed/"]');
    const src = iframe?.getAttribute('src') || '';
    const title = iframe?.getAttribute('title') || null;
    const iframeId = iframe?.id || null;

    let videoId = null;
    let videoUrl = src;

    try {
      if (src) {
        const url = new URL(src, window.location.origin);
        videoUrl = url.toString();

        const parts = url.pathname.split('/').filter(Boolean);
        videoId = parts[parts.length - 1] || null;
      }
    } catch (err) {
      console.warn('rw-eventlog: failed to parse iframe src', src, err);
    }

    return {
      index,
      playerElement,
      iframe,
      iframeId,
      videoId,
      title,
      videoUrl
    };
  }

  function detectPlyrPlayers() {
    return Array.from(document.querySelectorAll('.plyr'));
  }

  function applyCorrectPlyrRatio(root = document) {
    const pathname = window.location.pathname;

    if (!pathname.startsWith('/products/'))
      return;

    const parts = window.location.pathname.split('/').filter(Boolean);    


    const handle = parts[parts.length - 1];

    // if (!/^\/products\/invidium-phaser\/?$/.test(window.location.pathname))
    //   return;

    const affectedProducts = new Set([
      'invidium-phaser',
      'cynosium-modulated-delay',
      'euphorium-fuzz',
      'plurious-chorus-vibrato',
      'epiphanous-overdrive',
    ]);

    if (!affectedProducts.has(handle))
      return;

    const players = root.querySelectorAll('.plyr--youtube');

    players.forEach((player) => {
      const iframe = player.querySelector('iframe');
      const wrapper = player.querySelector('.plyr__video-wrapper');

      if (!iframe || !wrapper) return;

      const width = parseFloat(iframe.getAttribute('width'));
      const height = parseFloat(iframe.getAttribute('height'));

      if (!width || !height) return;

      const padding = `${(height / width) * 100}%`;

      // Mark so we know this was our fix
      wrapper.dataset.rwRatioFixed = '1';
      //wrapper.style.paddingBottom = '100%';// padding;
      wrapper.classList.add('rw-force-16-9');
    });
  }


  function buildVideoCheckpoints(durationSeconds) {
    const max = Math.floor(Number(durationSeconds || 0));
    const points = new Set();

    for (let i = 1; i <= 10; i++) {
      if (i <= max) points.add(i);
    }

    [15, 20, 25, 30].forEach((n) => {
      if (n <= max) points.add(n);
    });

    for (let i = 40; i <= max; i += 10) {
      points.add(i);
    }

    return Array.from(points).sort((a, b) => a - b);
  }

  function bindPlyrEvents(analytics) {
    const players = detectPlyrPlayers();

    if (!players.length) {
      console.log('rw-eventlog: no Plyr players found');
      return false;
    }

    const videos = players.map(extractVideoInfo);

    console.log(`rw-eventlog: ${videos.length} Plyr player(s) found`);
    console.table(
      videos.map(v => ({
        index: v.index,
        videoId: v.videoId,
        title: v.title,
        iframeId: v.iframeId,
        videoUrl: v.videoUrl
      }))
    );

    videos.forEach((video) => {
      if (!video.playerElement || video.playerElement.dataset.rwEventBound === '1') {
        return;
      }

      video.playerElement.dataset.rwEventBound = '1';

      let checkpoints = [];
      const fired = new Set();
      let lastTime = 0;

       function ensureCheckpoints(player) {
        if (!player) return;

        const duration = Math.floor(Number(player.duration || 0));

        if (duration > 0 && checkpoints.length === 0) {
          checkpoints = buildVideoCheckpoints(duration);

          console.log('rw-eventlog: checkpoints initialised', {
            index: video.index,
            videoId: video.videoId,
            duration,
            checkpoints
          });
        }
      }
      
      video.playerElement.addEventListener('play', (e) => {

        const player = e.detail?.plyr;
        ensureCheckpoints(player);

        var logData = {
          eventType: "video_play",
          sessionId: analytics.sessionId,
          shortId: analytics.shortId,
          pagePath: window.location.pathname,
          videoId: video.videoId,
          title: video.title,
          videoUrl: video.videoUrl,
          iframeId: video.iframeId,
          index: video.index,
          ts: new Date().toISOString(),
          url: window.location.href,
          referrer: document.referrer || null,
          userAgent: navigator.userAgent,
          currentTime: Number(player?.currentTime || 0),
          duration: Number(player?.duration || 0),
        };

        console.log('rw-eventlog: video_play', logData);

        fetch("https://redwitchapi.azurewebsites.net/api/logevent?code=PG_QPtJKDN_bf6KUcH3r3F5ntW5UK8SlxoyMuSOCa-RtAzFuj4ceng==", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          keepalive: true,
          body: JSON.stringify(
            logData
          )
        });        

      });

      video.playerElement.addEventListener('ready', (e) => {
        const player = e.detail?.plyr;
        ensureCheckpoints(player);

        console.log('rw-eventlog: video_ready', {
          index: video.index,
          videoId: video.videoId,
          title: video.title,
          duration: Number(player?.duration || 0)
        });
      });

      video.playerElement.addEventListener('pause', (e) => {
        const player = e.detail?.plyr;

        console.log('rw-eventlog: video_pause', {
          index: video.index,
          videoId: video.videoId,
          title: video.title,
          currentTime: Number(player?.currentTime || 0),
          duration: Number(player?.duration || 0)
        });
      });

      video.playerElement.addEventListener('ended', (e) => {
        const player = e.detail?.plyr;
        const duration = Math.floor(Number(player?.duration || 0));

        if (duration > 0 && !fired.has(duration)) {
          fired.add(duration);

          console.log('rw-eventlog: video_watched_seconds', {
            index: video.index,
            videoId: video.videoId,
            title: video.title,
            currentTime: Number(player?.currentTime || 0),
            duration: Number(player?.duration || 0),
            watchedSecondsCheckpoint: duration
          });
        }

        console.log('rw-eventlog: video_complete', {
          index: video.index,
          videoId: video.videoId,
          title: video.title,
          currentTime: Number(player?.currentTime || 0),
          duration: Number(player?.duration || 0)
        });
      });

      video.playerElement.addEventListener('timeupdate', (e) => {

        
        const player = e.detail?.plyr;
        ensureCheckpoints(player);

        const currentTime = Math.floor(Number(player?.currentTime || 0));
        const delta = currentTime - lastTime;

        var fbp = rwGetCookie('_fbp');
        var fbc = rwGetCookie('_fbc');


        if (delta > 0 && delta <= 2) {
          checkpoints.forEach((checkpoint) => {
            if (currentTime >= checkpoint && !fired.has(checkpoint)) {
              fired.add(checkpoint);

              var logData = {
                eventType: "video_watched_seconds",
                sessionId: analytics.sessionId,
                shortId: analytics.shortId,
                pagePath: window.location.pathname,
                videoId: video.videoId,
                currentTime: Number(player?.currentTime || 0),
                duration: Number(player?.duration || 0),
                watchedSecondsCheckpoint: checkpoint,
                title: video.title,
                videoUrl: video.videoUrl,
                iframeId: video.iframeId,
                index: video.index,
                ts: new Date().toISOString(),
                url: window.location.href,
                referrer: document.referrer || null,
                userAgent: navigator.userAgent,
                fbp: fbp,
                fbc: fbc                        
              };

              console.log('rw-eventlog: video_watched_seconds', logData);

              fetch("https://redwitchapi.azurewebsites.net/api/logevent?code=PG_QPtJKDN_bf6KUcH3r3F5ntW5UK8SlxoyMuSOCa-RtAzFuj4ceng==", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                keepalive: true,
                body: JSON.stringify(
                  logData
                )
              })
              .then(function (res) {
                return res.json();
              })
              .then(function (result) {
                if (!result || !result.tracked || !result.eventId || !result.eventType) {
                  return;
                }

                if (typeof fbq === 'function') {
                  fbq('trackCustom', result.eventType, {}, { eventID: result.eventId });
                }
              })
              .catch(function (err) {
                console.warn("rw-eventlog: failed", err);
              });              
            }
          });
        }

        lastTime = currentTime;
      });

      console.log('rw-eventlog: bound play listener', {
        index: video.index,
        videoId: video.videoId,
        title: video.title
      });
    });

    applyCorrectPlyrRatio();

    return true;
  }

function bindAddToCartEvents(analytics) {
  if (document.body.dataset.rwCartBound)
   return;
      
  document.body.dataset.rwCartBound = '1';

      document.addEventListener('click', function (e) {
        const target = e.target instanceof Element ? e.target : null;
        if (!target) return;

        let eventType = null;

        if (target.closest('[data-add-to-cart-trigger]')) {
          eventType = 'add_to_cart';
        } else if (target.closest('button.afterpay-logo')) {
          eventType = 'afterpay_click';
        } else if (target.closest('square-placement')) {
          eventType = 'afterpay_click';
        } else if (target.closest('#more-payment-options-link, .shopify-payment-button__more-options')) {
          eventType = 'more_payment_options_click';
        } else if (target.closest('shopify-paypal-button')) {
          eventType = 'paypal_area_click';
        } else if (target.closest('a[href*="sweetwater.com/store/manufacturer/Red_Witch"]')){
          eventType = 'sweetwater_click';
        } else if (target.closest('button[name="checkout"]')) {
          eventType = "checkout_click";
        }

        if (!eventType) return;

        console.log(eventType + ' triggered or clicked', window.location.pathname);

        var logData = {
                  eventType: eventType,
                  sessionId: analytics.sessionId,
                  shortId: analytics.shortId,
                  pagePath: window.location.pathname,
                  videoId: null,
                  title: null,
                  videoUrl: null,
                  iframeId: null,
                  index: null,
                  ts: new Date().toISOString(),
                  url: window.location.href,
                  referrer: document.referrer || null,
                  userAgent: navigator.userAgent
                };

          console.log('rw-eventlog: add_to_cart', logData);


          fetch("https://redwitchapi.azurewebsites.net/api/logevent?code=PG_QPtJKDN_bf6KUcH3r3F5ntW5UK8SlxoyMuSOCa-RtAzFuj4ceng==", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            keepalive: true,
            body: JSON.stringify(
              logData
            )
          });        

        });

}


  function startRwEventLog() {
    const analytics = window.rwAnalytics;

    if (!analytics?.sessionId) {
      console.warn('rw-eventlog: rwAnalytics not available');
      return;
    }

    console.log('rw-eventlog ready', analytics);

    setTimeout(() => {
      const bound = bindPlyrEvents(analytics);

      if (!bound) {
        console.log('rw-eventlog: retrying Plyr detection in 3000ms');

        setTimeout(() => {
          bindPlyrEvents(analytics);
        }, 3000);
      }

      bindAddToCartEvents(analytics);

    }, 1000);
  }

  if (window.rwAnalytics) {
    startRwEventLog();
  } else {
    window.addEventListener('rw_analytics_ready', startRwEventLog, { once: true });
  }
});